export const apiBaseURL = 'https://api.stryd.com';
